import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type GraphqlResponse } from '../../shared/interfaces/graphql/graphql-response.interface';
import { type AuthUserGql } from '../graphql/interfaces/auth-user-gql.interface';
import { authUserFindMeQuery } from '../graphql/queries/auth-user-find-me.query';
import { CREW_ADMIN_PROFILES, type AuthUserProfile } from '../constants/auth-user-profile.enum';
import { apiRestClient } from '@Lib/http/rest-client';

interface Data {
  user_find_me: AuthUserGql;
}

export interface AuthUserFindMeResult {
  profile: AuthUserProfile;
  isCrewAdmin: boolean;
}

export const useAuthUserFindMeQuery = (
  token: string,
  queryOptions?: Omit<UseQueryOptions<AuthUserFindMeResult>, 'queryKey' | 'queryFn'>
) => {
  const queryFn = async (): Promise<AuthUserFindMeResult> => {
    const response = await apiRestClient.post<GraphqlResponse<Data>>('', authUserFindMeQuery());

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const { profile } = (response.data.data as Data).user_find_me;
    return { profile, isCrewAdmin: CREW_ADMIN_PROFILES.has(profile) };
  };

  return useQuery({ queryKey: ['user_find_me', token], queryFn, ...queryOptions });
};
